import { render, staticRenderFns } from "./CardDeliveries.vue?vue&type=template&id=1734ec4c&"
import script from "./CardDeliveries.vue?vue&type=script&lang=ts&"
export * from "./CardDeliveries.vue?vue&type=script&lang=ts&"
import style0 from "./CardDeliveries.vue?vue&type=style&index=0&id=1734ec4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports